import styled from '@emotion/styled';

const FilesTableContent = styled('tbody')(({ theme }) => ({
  marginTop: 0,
  marginBottom: 8,
  padding: '0 24px',
  backgroundColor: theme.palette.action.hover,
}));

export default FilesTableContent;
